import appFeature from '../assets/images/AppFeature-removebg-preview.png';
import CustomCarousal from '../components/CustomCarousal.js';
import { useEffect,useState } from 'react';
import { apiHandler } from '../assets/api/index.js';
import { endpoint } from '../assets/api/endpoint.js';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";

const AppFeature = ()=>{
     const [slideData, setSlideData] = useState();
     const { accessToken } = useSelector((state) => state.loginInfo);

      useEffect(() => {
             const fetchFeedback = async () => {
                 try {
                     // setShowSpinner(true);
                     const result = await apiHandler({
                         url: endpoint.FETCH_FEEDBACK,
                         method: "GET",
                         authToken: accessToken?.accessToken,
                     });
     
                     if (result?.data.code !== 500) {
                         setSlideData(result?.data);
                     } else {
                         toast.error("Something went wrong");
                     }
                 } catch (error) {
                     toast.error("Something went wrong");
                 } finally {
                     // setShowSpinner(false);
                 }
             };
             accessToken && fetchFeedback();
         }, [accessToken])
    return(
        <>
           {/* -----------------------------APP FEATURES---------------------------------- */}
                   <div >
                    <div className="container text-center py-5 mt-5 mt-sm-0">
                        <h2 className="mb-3 app-feature-txt">App's Features</h2>
                        <p className="mb-3 mb-sm-5">Experience the best way to connect and play!</p>
                        <div className="row align-items-center">
                            {/* Left Side Features */}
                            <div className="col-md-4 text-md-end text-center mb-4 mb-md-0" style={{ padding: '10px' }}>
                                <div className="mb-0 mb-sm-4">
                                    <div className="d-flex justify-content-md-end justify-content-center align-items-center">
                                        {/* <i className="bi bi-brush fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Sleek & Modern Design</h4>
                                            <p style={{ color: '#6c757d' }}> Enjoy an intuitive and user-friendly interface designed for seamless navigation..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-0 mb-sm-4">
                                    <div className="d-flex justify-content-md-end justify-content-center align-items-center">
                                        {/* <i className="bi bi-cloud fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Cloud-Powered Data</h4>
                                            <p style={{ color: '#6c757d' }}>Access your game details anytime, anywhere, with secure cloud storage.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="d-flex justify-content-md-end justify-content-center align-items-center">
                                        {/* <i className="bi bi-tag fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Affordable for Everyone</h4>
                                            <p style={{ color: '#6c757d' }}> Get premium features at an unbeatable price.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            {/* Center Mockup */}
                            <div className="col-md-4 text-center">
                                <img
                                    src={appFeature}
                                    width='700px'
                                    height='700px'
                                    alt="Mobile Mockup"
                                    className="img-fluid"
                                />
                            </div>
        
                            {/* Right Side Features */}
                            <div className="col-md-4 text-md-start text-center">
                                <div className="mb-0 mb-sm-4">
                                    <div className="d-flex justify-content-md-start justify-content-center align-items-center">
                                        {/* <i className="bi bi-shield-lock fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Interactive Mobile Experience</h4>
                                            <p style={{ color: '#6c757d' }}> Enjoy a visually stunning mobile-friendly design for a smooth experience.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-0 mb-sm-4">
                                    <div className="d-flex justify-content-md-start justify-content-center align-items-center">
                                        {/* <i className="bi bi-send fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Top-Notch Security</h4>
                                            <p style={{ color: '#6c757d' }}> Your data is encrypted and protected with the latest security measures.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-0 mb-sm-4">
                                    <div className="d-flex justify-content-md-start justify-content-center align-items-center">
                                        {/* <i className="bi bi-arrow-repeat fs-3 me-3"></i> */}
                                        <div>
                                            <h4>Effortless Game Setup</h4>
                                            <p style={{ color: '#6c757d' }}>Easily create and join games with just a few taps.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div className='container'>
                        <div className='py-5 people-thought-carousal' style={{ marginBottom: '25px' }}>
                            <h2 className="carousel-title mb-5">
                                What people Think <span>About Us</span>
                            </h2>
                            <CustomCarousal slideData={slideData} />
                        </div>
                    </div>
                    </div>
        </>
    )
}
export default AppFeature;